<template>
	<div>
		<div class="dl-pg" :class="{ 'is-wx': iswx == 1 }">
			<!-- 品牌区 -->
			<section class="dl-hero">
				<div class="dl-brand">
					<!-- logo1.png 是叮当云品牌标（深蓝底 + 金色云算盘），已抹掉母版底部的
					     「叮当云」字样，品牌名由下面这行文字承担；
					     logo.png 是脚手架自带的安卓机器人占位图，不要用 -->
					<img class="dl-logo" src="../assets/images/logo1.png" alt="叮当云">
					<div class="dl-name">叮当云</div>
					<span class="dl-rule"></span>
				</div>
				<!-- 极低对比的山形，延续茶山意象 -->
				<svg class="dl-hill" viewBox="0 0 375 90" preserveAspectRatio="none" aria-hidden="true">
					<path d="M0,44 C80,14 150,18 210,40 C268,61 320,58 375,34 L375,90 L0,90 Z" fill="#FFFFFF" fill-opacity="0.05"/>
					<path d="M0,68 C74,50 142,52 204,70 C262,86 320,84 375,66 L375,90 L0,90 Z" fill="#000000" fill-opacity="0.05"/>
				</svg>
			</section>

			<!-- 下载区（微信内无法下载，不展示按钮） -->
			<section v-if="iswx != 1" class="dl-action">
				<div class="dl-box">
					<!-- 仅安卓：叮当云没有 iOS 包，不再给一个点了没反应的按钮 -->
					<template v-if="isIos">
						<div class="dl-tip">叮当云暂仅支持安卓，请使用安卓手机打开本页下载</div>
					</template>
					<template v-else-if="loading">
						<div class="dl-tip">正在获取最新版本…</div>
					</template>
					<template v-else-if="!downUrl">
						<div class="dl-tip">最新版本正在准备中，请稍后再来</div>
					</template>
					<template v-else>
						<a :href="downUrl" target="_self" class="dl-btn" ref="downloadBtn">安卓 APP 下载</a>
					</template>

					<!-- 版本信息：没有记录时整块隐藏 -->
					<div v-if="hasVersion && !isIos" class="dl-meta">
						<span v-if="versionName" class="dl-ver">{{ versionName }}</span>
						<p v-if="updateContext" class="dl-note" v-html="updateContextText"></p>
					</div>
				</div>
			</section>
		</div>

		<!-- 微信内置浏览器：品牌页垫底 + 右上角引导 -->
		<div v-if="iswx == 1" class="dl-wx">
			<wxCom/>
		</div>
	</div>
</template>
<script>
import { isWeiXin } from '@/libs/util'
import device from '@/libs/device'
import aguiApi from '@/api/aguiApi'
import wxCom from '@/components/wxCom'

export default {
	data() {
		return {
			iswx: 0,
			isIos: false,
			loading: true,
			hasVersion: false,
			downUrl: '',
			versionName: '',
			updateContext: ''
		}
	},
	components: { wxCom },
	computed: {
		/**
		 * 更新内容可能带换行，转成 <br> 展示。
		 * 先做 HTML 转义再替换换行 —— 后台是运营手填的纯文本，
		 * 直接 v-html 会把尖括号当标签解析掉。
		 */
		updateContextText() {
			const escaped = String(this.updateContext)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
			return escaped.replace(/\r?\n/g, '<br>')
		}
	},
	mounted() {
		// 2026-10-22：iOS 也要请求一次（用于判断 has_version / 展示版本），
		// 但不会自动跳转下载 —— 叮当云只有安卓包。
		this.isIos = !!device.ios
		if (isWeiXin()) {
			this.iswx = 1
			return
		}
		this.getDownUrl()
	},
	methods: {
		async getDownUrl() {
			try {
				const res = await aguiApi.getDownloadApp({})
				if (res) {
					this.hasVersion = !!res.has_version
					this.downUrl = res.app_url || ''
					this.versionName = res.app_name || ''
					this.updateContext = res.update_context || ''
				}
			} catch (e) {
				// 接口异常不拦页面：保持「稍后再来」的兜底文案，
				// javaAxios 已统一 toast 过错误原因，这里不再重复弹。
				this.downUrl = ''
			} finally {
				this.loading = false
			}
			if (!this.downUrl || this.isIos) {
				return
			}
			// 与原富迪布谷页面一致：停留 1 秒后自动触发下载
			const _this = this
			setTimeout(function () {
				const btn = _this.$refs.downloadBtn
				if (btn) {
					btn.click()
				}
			}, 1000)
		}
	}
}
</script>
<style lang="less" scoped>

/* 叮当云品牌色：与登录/注册等页面一致（全站 38 处使用 #8A3E2F） */
@brand: #8A3E2F;
@brand-deep: #6C2E21;
@gold: #FFC200;
@paper: #FFF8F4;

.dl-pg{
	position: relative;
	display: flex;
	flex-direction: column;
	height: 100vh;
	height: 100dvh;
	min-height: 520px;
	overflow: hidden;
	background: @paper;
	-webkit-font-smoothing: antialiased;
}

/* 品牌区：茶褐渐层，垂直居中承载 logo 与品牌名 */
.dl-hero{
	position: relative;
	flex: 0 0 58%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 24px 40px;
	background: linear-gradient(165deg, #A9553F 0%, @brand 42%, @brand-deep 100%);

	/* 顶部暖光，呼应茶山清晨的意象 */
	&::before{
		content: "";
		position: absolute;
		top: -30%;
		left: 50%;
		width: 160%;
		height: 86%;
		transform: translateX(-50%);
		background: radial-gradient(closest-side, rgba(255, 194, 0, .34), rgba(255, 150, 90, .10) 56%, rgba(255, 120, 60, 0) 76%);
	}
}

.dl-brand{
	position: relative;
	z-index: 2;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.dl-logo{
	width: 96px;
	height: 96px;
	display: block;
	border-radius: 22px;
	background: #FFFFFF;
	object-fit: contain;
	filter: drop-shadow(0 14px 28px rgba(60, 20, 8, .32));
}

.dl-name{
	margin-top: 22px;
	font-size: 26px;
	line-height: 1;
	font-weight: 600;
	letter-spacing: .2em;
	text-indent: .2em;
	color: #FFFFFF;
}

.dl-rule{
	margin-top: 16px;
	width: 24px;
	height: 3px;
	border-radius: 3px;
	background: linear-gradient(90deg, #FFE7AD, @gold);
}

.dl-hill{
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	display: block;
	pointer-events: none;
}

/* 下载区：浅暖底 + 强对比主按钮 */
.dl-action{
	position: relative;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 24px calc(16px + env(safe-area-inset-bottom));
}

.dl-box{
	width: 100%;
	max-width: 320px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.dl-btn{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 264px;
	max-width: 100%;
	height: 52px;
	border-radius: 26px;
	background: linear-gradient(135deg, #FFD34D 0%, @gold 55%, #F0AB00 100%);
	box-shadow: 0 14px 26px rgba(240, 171, 0, .30), inset 0 1px 0 rgba(255, 255, 255, .34);
	color: @brand-deep;
	font-size: 18px;
	font-weight: 700;
	letter-spacing: .14em;
	text-indent: .14em;
	text-decoration: none;
	transition: transform .12s ease, box-shadow .12s ease;

	&:active{
		transform: scale(.97);
		box-shadow: 0 8px 16px rgba(240, 171, 0, .26);
	}
}

.dl-tip{
	padding: 0 8px;
	text-align: center;
	font-size: 14px;
	line-height: 22px;
	color: #8A6A5C;
}

.dl-meta{
	margin-top: 22px;
	width: 100%;
	text-align: center;
}

.dl-ver{
	display: inline-block;
	padding: 2px 10px;
	border-radius: 10px;
	background: rgba(138, 62, 47, .08);
	color: @brand;
	font-size: 12px;
	line-height: 18px;
}

.dl-note{
	margin-top: 10px;
	font-size: 12px;
	line-height: 20px;
	color: #A08174;
	word-break: break-word;
}

/* 微信内置浏览器：无下载动作，品牌区占满整屏，上方留出引导条位置 */
.dl-pg.is-wx{
	.dl-hero{
		flex: 1;
		padding-top: 150px;
	}
	.dl-action{
		display: none;
	}
}

/* 微信内置浏览器：提示层叠在品牌页之上 */
.dl-wx{
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 30;

	/* 提示箭头原图为深色，深色底上几乎不可见 → 反白 */
	::v-deep .weixin-tip .weixin-top img{
		filter: brightness(0) invert(1) drop-shadow(0 2px 6px rgba(60, 20, 8, .28));
	}
}

/* 矮屏（横屏 / 小尺寸机型）压缩品牌区，避免下载按钮被挤出 */
@media (max-height: 640px){
	.dl-hero{
		flex: 0 0 56%;
		padding-bottom: 24px;
	}
	.dl-logo{
		width: 80px;
		height: 80px;
	}
	.dl-name{
		margin-top: 16px;
		font-size: 22px;
	}
}
</style>
